<template>
  <v-col class="ma-0 pa-0" cols="12">
    <v-col class="ma-0 pa-0 pl-5 pr-5 mb-2" cols="12" align="left"
           style="font-weight:bold;">
      {{t('all')}}
    </v-col>
    <template v-if="fetchLoading == false">
      <v-col class="ma-0 pa-0 pl-5 pr-5" cols="12">
        <v-col id="data_box" class="ma-0 pa-0" cols="12">
          <v-row class="ma-0 pa-0" align="center">
            <v-col class="ma-0 pa-0" cols="3">
              <v-col class="ma-0 pa-3 pb-0 pl-5" cols="12" align="left"
                     style="font-size:0.9rem;font-weight:bold;">
                {{tsc('last30DaysVisitors')}}
              </v-col>
              <v-col class="ma-0 pa-3 pt-1 pl-5 pr-5" cols="12">
                <v-col id="data_people_box" class="ma-0 pa-0" cols="12">
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{t('all')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'15,938' + tsc('peopleCount')}}</v-col>
                    </v-col>
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{tsc('faceRecognition')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'13,658' + tsc('peopleCount')}}</v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col class="ma-0 pa-0 pr-2 pb-3" cols="12">
                <BarChart :data="chartData" :options="chartOptions"
                          :height="150"></BarChart>
              </v-col>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
              <v-col class="ma-0 pa-3 pb-0 pl-5" cols="12" align="left"
                     style="font-size:0.9rem;font-weight:bold;">
                {{tsc('last30DaysVisitors')}}
              </v-col>
              <v-col class="ma-0 pa-3 pt-1 pl-5 pr-5" cols="12">
                <v-col id="data_people_box" class="ma-0 pa-0" cols="12">
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{t('man')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'7,503' + tsc('peopleCount')}}</v-col>
                    </v-col>
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{t('weman')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'8,435' + tsc('peopleCount')}}</v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col class="ma-0 pa-0 pr-2 pb-3" cols="12">
                <BarChart :data="chartData" :options="chartOptions"
                          :height="150"></BarChart>
              </v-col>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
              <v-col class="ma-0 pa-3 pb-0 pl-5" cols="12" align="left"
                     style="font-size:0.9rem;font-weight:bold;">
                {{tsc('last30DaysVisitors')}}
              </v-col>
              <v-col class="ma-0 pa-3 pt-1 pl-5 pr-5" cols="12">
                <v-col id="data_people_box" class="ma-0 pa-0" cols="12">
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{tsg('new')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'7,503' + tsc('peopleCount')}}</v-col>
                    </v-col>
                    <v-col class="ma-0 pa-1" cols="6">
                      <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{tsg('repeater2')}}</v-col>
                      <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                             align="left">{{'8,435' + tsc('peopleCount')}}</v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col class="ma-0 pa-0 pr-2 pb-3" cols="12">
                <BarChart :data="chartData" :options="chartOptions"
                          :height="150"></BarChart>
              </v-col>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
              <v-col class="ma-0 pa-3 pb-0 pl-5" cols="12" align="left"
                     style="font-size:0.9rem;font-weight:bold;">
                {{tsc('last30DaysVisitors')}}
              </v-col>
              <v-col class="ma-0 pa-3 pt-1 pl-5 pr-5" cols="12">
                <v-col id="data_people_box" class="ma-0 pa-0" cols="12">
                  <v-col class="ma-0 pa-1" cols="12">
                    <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                           align="left">{{t('sales')}}</v-col>
                    <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                           align="left">{{'12,591,543' + t('yen')}}</v-col>
                  </v-col>
                </v-col>
              </v-col>
              <v-col class="ma-0 pa-0 pr-2 pb-3" cols="12">
                <BarChart :data="chartData" :options="chartOptions"
                          :height="150"></BarChart>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </template>
    <template v-else>
      <v-col class="ma-0 pa-0 pl-5 pr-5" cols="12">
        <v-col class="ma-0 pa-0" cols="12">
          <v-skeleton-loader :boilerplate="false" elevation="0" dark
                             type="image" width="100%" height="12rem"
          ></v-skeleton-loader>
        </v-col>
      </v-col>
    </template>

    <v-col class="ma-0 pa-0 mt-5" cols="12">
      <v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
    </v-col>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
import BarChart from "@/components/barChart.js";
import {VisitorOption} from '@/components/chartOptions';
import { ChartData3 } from '@/views/whitetest/sampleData';

export default {
  props: {
    fetchLoading: Boolean,
  },
  components: {
    BarChart
  },
  mixins: [mixin.common],
  data: () => ({
    chartOptions: VisitorOption,
    chartData: ChartData3
  }),
  methods: {
    tsc(t) {
      return this.$t("lang.storeSearch." + t);
    },
    tsg(t) {
      return this.$t("lang.group." + t);
    },
  }
}
</script>

<style lang="scss" scoped>
#data_box {
  background-color: #34363C;
  border-radius: 4px;
}
#data_people_box {
  background-color: #5C5D62;
  border-radius: 4px;
}
#data_sub_title {
  color: #CECED0;
  font-size: 0.8rem;
}
#data_count {
  font-weight: bold;
}
#middle_divider {
  background-color: #4C4C4C;
}
</style>